import { useTranslation } from "react-i18next";
import { ProductDownloads } from "@/components/site/ProductDownloads";
import { StandalonePageShell } from "@/components/site/StandalonePageShell";
import { useSiteContent } from "@/lib/useSiteContent";

export default function ProductMediaCenter() {
  const { t } = useTranslation();
  const home = useSiteContent("home");
  const contact = useSiteContent("contact");
  const dealers = useSiteContent("dealers");

  return (
    <StandalonePageShell
      content={{ home, contact, dealers }}
      eyebrow={t("resourceCenter.eyebrow")}
      title={t("resourceCenter.title")}
      description={t("resourceCenter.intro")}
    >
      <ProductDownloads />
    </StandalonePageShell>
  );
}
